(function () {
  let total_stock = 0; // 虚拟库存数量
  let min_interval = 0; // 最小库存
  let final_total_stock = 0; // 最终数量
  let start_time = new Date(); // 开始时间
  let decrease_interval = 0; // 减少间隔
  let decrease_amount_per_interval = []; //减少频率
  let available_main = false; // 是否可用

  // 差值计算
  function calcRemainingInventory(
    totalInventory,
    startTime,
    intervalHours,
    reduceNumbers
  ) {
    console.log(
      "calcRemainingInventory-------------------------------",
      totalInventory,
      startTime,
      intervalHours,
      reduceNumbers
    );
    if (!Array.isArray(reduceNumbers) || reduceNumbers.length === 0)
      return totalInventory;
    if (intervalHours <= 0) return totalInventory;
    if (reduceNumbers.length === 0 || intervalHours <= 0) return totalInventory;

    const start = startTime instanceof Date ? startTime : new Date(startTime);
    const passedHours = (Date.now() - start.getTime()) / (1000 * 60 * 60);
    const passedPeriods = Math.floor(passedHours / intervalHours);

    if (passedPeriods <= 0) return totalInventory;

    const cycleLength = reduceNumbers.length;
    const fullCycles = Math.floor(passedPeriods / cycleLength);
    const remainingPeriods = passedPeriods % cycleLength;
    const cycleSum = reduceNumbers.reduce((sum, n) => sum + n, 0);
    let result = totalInventory - fullCycles * cycleSum;

    for (let i = 0; i < remainingPeriods; i++) {
      result -= reduceNumbers[i] || 0;
    }

    return result < 0 ? 0 : result;
  }

  // 基础值获取函数
  function getNormalDatas() {
    // 获取URL中的variant参数

    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get("variant")
      ? urlParams.get("variant")
      : "";
    let variant;
    if (variantParam) {
      variant = document.querySelector(
        `.product_new_progress_container input[data-vid="${variantParam}"]`
      );
      if (!variant) {
        // 如果找不到对应的variant，隐藏进度条
        const progressContainer = document.querySelector(
          ".product_new_progress_container"
        );
        if (progressContainer) {
          document.querySelector(".progress-bar-title").style.display = "none";
          document.querySelector(".progress-bar-container").style.display =
            "none";
          return;
        }
      } else {
        document.querySelector(".progress-bar-title").style.display = "block";
        document.querySelector(".progress-bar-container").style.display =
          "flex";
      }
    } else {
      setTimeout(() => {
        var firstVariantId =
          document.querySelector("product-variants").product.variants[0].id;
        variant = document.querySelector(
          `.product_new_progress_container input[data-vid="${firstVariantId}"]`
        );
        if (!variant) {
          // 如果找不到对应的variant，隐藏进度条
          const progressContainer = document.querySelector(
            ".product_new_progress_container"
          );
          if (progressContainer) {
            document.querySelector(".progress-bar-title").style.display =
              "none";
            document.querySelector(".progress-bar-container").style.display =
              "none";
            return;
          } else {
            document.querySelector(".progress-bar-title").style.display =
              "block";
            document.querySelector(".progress-bar-container").style.display =
              "flex";
          }
        }
      }, 100);
    }
    if (variant) {
      const totalStock = variant.getAttribute("data-totalStock");
      const startTime = variant.getAttribute("data-startTime");
      const decreaseInterval = variant.getAttribute("data-decreaseInterval");
      const minInterval = variant.getAttribute("data-minInterval");
      const marketingCopy = variant.getAttribute("data-marketingCopy");
      const decreaseAmountPerInterval = variant.getAttribute(
        "data-decreaseAmountPerInterval"
      );
      const available = variant.getAttribute("data-available");

      total_stock = totalStock;
      min_interval = minInterval;
      start_time = startTime;
      decrease_interval = decreaseInterval;
      decrease_amount_per_interval = decreaseAmountPerInterval;
      marketing_copy = marketingCopy;
      available_main = available;
      // 将decrease_amount_per_interval转换为数组
      try {
        let attr = variant.getAttribute("data-decreaseAmountPerInterval");
        if (attr) {
          if (attr.trim().startsWith("[")) {
            decrease_amount_per_interval = JSON.parse(attr);
          } else {
            decrease_amount_per_interval = attr.split(",").map(Number);
          }
        } else {
          decrease_amount_per_interval = [];
        }
      } catch (e) {
        decrease_amount_per_interval = [];
      }

      // if (available == "false" || !available) {
      //   document.querySelector("#navSoldOutBtn").style.display = "flex";
      //   document.querySelector("#navAddToCarBtn").style.display = "none";
      //   document.querySelector("#navGoToCheckoutBtn").style.display = "none";
      // } else {
      //   document.querySelector("#navSoldOutBtn").style.display = "none";
      //   document.querySelector("#navAddToCarBtn").style.display = "flex";
      //   document.querySelector("#navGoToCheckoutBtn").style.display = "flex";
      // }

      final_total_stock = calcRemainingInventory(
        total_stock,
        start_time,
        decrease_interval,
        decrease_amount_per_interval
      );
      if (final_total_stock == 0) {
        final_total_stock = min_interval;
      }
      if (marketingCopy) {
        let titleEl = document.querySelector(".progress-bar-title");
        if (titleEl) titleEl.innerHTML = marketingCopy;
      }
      if (final_total_stock) {
        let descEl = document.querySelector(".progress-bar-desc");
        if (descEl) descEl.innerHTML = final_total_stock + " Items Left";
      }

      // 赋值给对应的元素
      document
        .querySelectorAll(".progress-wrapper")
        .forEach(function (progressWrapper) {
          // console.log('cs')
          const barFill = progressWrapper.querySelector(".progress-bar-fill");
          const icon = progressWrapper.querySelector(".progress-icon");
          let percent = Math.min(final_total_stock / total_stock, 1);
          if (final_total_stock == 0) {
            percent = 0;
          }
          barFill.style.width = `${percent * 100}%`;

          const wrapperWidth = progressWrapper.offsetWidth; // 适配100%宽度
          const iconBoxWidth = icon.offsetWidth;
          const minLeft = iconBoxWidth / 2;
          const maxLeft = wrapperWidth - iconBoxWidth / 2;
          let left = minLeft + percent * (maxLeft - minLeft) - 0.5;
          icon.style.left = `${left}px`;
        });
    }
  }
  // 页面加载时调用一次getNormalDatas函数
  document.addEventListener("DOMContentLoaded", function () {
    getNormalDatas(); // 首次加载立即调用
    setInterval(function () {
      getNormalDatas();
    }, 1000);
  });

  // 监听block-swatch__item的点击事件
  document.addEventListener("click", function (event) {
    if (event.target.closest(".block-swatch__item")) {
      // 等待URL变化后再调用方法
      setTimeout(() => {
        getNormalDatas();
        // if (available_main == "false" || !available_main) {
        //   document.querySelector("#navSoldOutBtn").style.display = "flex";
        //   document.querySelector("#navAddToCarBtn").style.display = "none";
        //   document.querySelector("#navGoToCheckoutBtn").style.display = "none";
        // } else {
        //   document.querySelector("#navSoldOutBtn").style.display = "none";
        //   document.querySelector("#navAddToCarBtn").style.display = "flex";
        //   document.querySelector("#navGoToCheckoutBtn").style.display = "flex";
        // }
      }, 100);
    }
  });
})();
